class Modals {
  init($modalTriggers) {
    this.focusableElementsString = 'a[href], area[href], input:not([disabled]), select:not([disabled]), textarea:not([disabled]), button:not([disabled]), iframe, object, embed, *[tabindex], *[contenteditable]';
    this.$modalTriggers = $modalTriggers;
    this.$modals = document.querySelectorAll('.js--modal');
    this.$page = document.querySelector('.js--main-page');

    this.moveModalsToFoot();
    this.bindModalTriggers();
  }


  moveModalsToFoot() {
    for (let i = 0; i < this.$modals.length; i += 1) {
      const $modal = this.$modals[i];
      document.body.appendChild($modal);
    }
  }

    bindModalTriggers() {
    for (let i = 0; i < this.$modalTriggers.length; i += 1) {
      const $btn = this.$modalTriggers[i];
        $btn.addEventListener('click', e => {
            const $modal = [...this.$modals].find($modal => $modal.id === e.target.dataset.modalId);
            this.openModal($modal);
      });
    }

    for (let i = 0; i < this.$modals.length; i += 1) {
      const $modal = this.$modals[i];
      const $closeButtons = $modal.querySelectorAll('.js--modal__close');

      for (let j = 0; j < $closeButtons.length; j += 1) {
        $closeButtons[j].addEventListener('click', () => this.closeModal($modal));
      }

    }
  }

  openModal($modal) {
    // if no associated modal
    if (!$modal) {
      return;
    }

    this.$page.setAttribute('aria-hidden', true);
    $modal.setAttribute('aria-hidden', false);
    this.focusFirstElement($modal);

    // add eventlistener to 'rest' of the page, to revert the focus to the modal
    this.$page.addEventListener('focusin', (e) => {
      this.focusFirstElement($modal);
    });
  }

  closeModal($modal) {
    this.$page.setAttribute('aria-hidden', false);
    $modal.setAttribute('aria-hidden', true);
  }

  focusFirstElement($modal) {
    const o = $modal.querySelectorAll(this.focusableElementsString);
    o[0].focus();
  }

  handleKeyDown(e) {
    if (e.which === 27) {
      this.setState({modalIsOpen: false});
      e.preventDefault();
    }
  }
}


const ModalsInstance = new Modals();
ModalsInstance.init(document.querySelectorAll('.js-overlay-button'));
